import { useEffect } from "react";
import { IoMicOutline } from "react-icons/io5";
import { MdPictureInPictureAlt } from "react-icons/md";
import type { Dispatch, SetStateAction } from "react";

import type { Group } from "types";

import styles from "./index.module.css";
import formatDuration from "utils/format-duration";

const TIMER_INTERVAL_MS = 1000;

export const CallData = ({
  groups,
  activeGroupId,
  isCallConnected,
  isPipSupported,
  isPipActive,
  onPipToggle,
  callDuration,
  setCallDuration,
}: {
  groups: Group[];
  activeGroupId?: number;
  isCallConnected: boolean;
  isPipSupported?: boolean;
  isPipActive?: boolean;
  onPipToggle?: () => void;
  callDuration: number;
  setCallDuration: Dispatch<SetStateAction<number>>;
}) => {
  useEffect(() => {
    const timer = window.setInterval(() => {
      setCallDuration((prev) => prev + 1);
    }, TIMER_INTERVAL_MS);

    return () => {
      if (timer) {
        window.clearInterval(timer);
      }
    };
  }, [setCallDuration]);

  const activeGroup = activeGroupId
    ? groups.find((group) => group.id === activeGroupId)
    : groups[0];

  return (
    <header className={styles.container}>
      {isPipSupported && (
        <button
          aria-label={isPipActive ? "Exit Picture-in-Picture" : "Enter Picture-in-Picture"}
          className={styles.pipButton}
          onClick={onPipToggle}
          title={isPipActive ? "Exit Picture-in-Picture" : "Enter Picture-in-Picture"}
          type="button"
        >
          <MdPictureInPictureAlt size={20} />
        </button>
      )}
      <div className={styles.header}>
        <span className={styles.duration}>{formatDuration(callDuration)}</span>
        <p className={styles.callStatus} data-connected={isCallConnected}>
          <IoMicOutline size={20} />
          {isCallConnected ? "Audio connected" : "Audio not connected"}
        </p>
      </div>

      {activeGroup && (
        <>
          <p className={styles.groupName}>
            <span>Group:</span> {activeGroup?.name}
          </p>
        </>
      )}
    </header>
  );
};
